import { render, staticRenderFns } from "./NotFoundView.vue?vue&type=template&id=529e2272&scoped=true&"
var script = {}
import style0 from "./NotFoundView.vue?vue&type=style&index=0&id=529e2272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529e2272",
  null
  
)

export default component.exports